import { useCallback } from 'react'

import { useLDClient } from 'launchdarkly-react-client-sdk'

import type { LaunchdarklyIdentify } from '@/shared/libs/launchdarkly/types'
import { getContext } from '@/shared/libs/launchdarkly/utils'

export const useLaunchdarklyIdentify = (): LaunchdarklyIdentify => {
  const ldClient = useLDClient()

  return useCallback(
    async (data) => {
      await ldClient?.identify(getContext(data))
    },
    [ldClient],
  )
}
